import { createBlueprint as r } from "@made-people/blueprint";
const p = r({
  slots: {
    wrapper: "flex gap-2 *:shrink-0 snap-mandatory scroll-px-[var(--spacing-x)] px-[var(--spacing-x)] -mx-[var(--spacing-x)] snap-x overflow-x-scroll overflow-y-visible box-border"
  },
  variants: {}
});
export {
  p as scrollWrapperBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
